import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Table as Table$1 } from '@zillow/constellation';
import PropTypes from 'prop-types';
import makeContentInteractive from '../../util/makeSpansInteractive.js';

var _excluded = ["head", "body"],
  _excluded2 = ["name"],
  _excluded3 = ["name"];
var BlockTable = function BlockTable(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  // eslint-disable-next-line zillow/react/prop-types
  attrs.head;
    attrs.body;
    var otherProps = _objectWithoutProperties(attrs, _excluded);
  var sectionMap = {
    head: Table$1.Header,
    body: Table$1.Body
  };
  var cellMap = {
    head: Table$1.HeaderCell,
    body: Table$1.Cell
  };

  // eslint-disable-next-line zillow/react/prop-types
  function TSection(_ref2) {
    var name = _ref2.name,
      props = _objectWithoutProperties(_ref2, _excluded2);
    var TagName = sectionMap[name];
    return /*#__PURE__*/React.createElement(TagName, props);
  }

  // eslint-disable-next-line zillow/react/prop-types
  function TCell(_ref3) {
    var name = _ref3.name,
      props = _objectWithoutProperties(_ref3, _excluded3);
    var TagName = cellMap[name];
    return /*#__PURE__*/React.createElement(TagName, props);
  }
  return /*#__PURE__*/React.createElement(Table$1.Responsive, null, /*#__PURE__*/React.createElement(Table$1, _extends({}, otherProps, {
    key: index
  }), ['head', 'body'].map(function (name) {
    return /*#__PURE__*/React.createElement(TSection, {
      name: name,
      key: name
    }, attrs[name] && attrs[name].map(function (_ref4, rowIndex) {
      var cells = _ref4.cells;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line zillow/react/no-array-index-key
        React.createElement(Table$1.Row, {
          name: name,
          key: rowIndex
        }, cells.map(function (_ref5, columnIndex) {
          var content = _ref5.content;
          return (
            /*#__PURE__*/
            // eslint-disable-next-line zillow/react/no-array-index-key
            React.createElement(TCell, {
              name: name,
              key: columnIndex
            }, makeContentInteractive(content))
          );
        }))
      );
    }));
  })));
};
BlockTable.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    appearance: PropTypes.string,
    size: PropTypes.string
  }),
  index: PropTypes.number
} : {};
var Table = BlockTable;

export { Table as default };
